import './style.scss';

// The "reconciliation in progress" state — shown while Source A + the children are
// fetched and compared (a few seconds on a large entity). Instead of a blank wait
// or a generic spinner, it echoes the feature's signature: the divergence-spine
// rail, animated as a "tally sweep" that reads as iElect scanning each unit. The
// serif headline matches the verdict it resolves into, so loading → loaded feels
// continuous. Variants keep one source of truth across the card, page and drawer.

const Scan = () => (
	<span
		className='rc-scan'
		aria-hidden='true'
	>
		<span className='rc-scan__beam' />
	</span>
);

export const ReconcilingState = ({ variant = 'card' }: { variant?: 'card' | 'page' | 'strip' }) => {
	if (variant === 'strip') {
		return (
			<div
				className='rc-strip rc-strip--checking'
				role='status'
				aria-live='polite'
			>
				<Scan />
				<span className='rc-strip__checking-label'>Checking units…</span>
			</div>
		);
	}

	const isPage = variant === 'page';
	return (
		<div
			className={`rc-reconciling rc-reconciling--${variant}`}
			role='status'
			aria-live='polite'
		>
			<span className='rc-reconciling__eyebrow'>Result reconciliation</span>
			<span className='rc-reconciling__title'>Reconciling</span>
			<span className='rc-reconciling__sub'>
				{isPage
					? 'iElect is comparing your uploaded result with every unit under it. This takes a moment.'
					: 'Checking your result against its units…'}
			</span>
			<Scan />
		</div>
	);
};
